import { Checkbox, Tooltip } from '@mui/material';

import Utils from '../../../utils/immersive_utils';

import './styles.scss';

export interface Item {
  name: string;
  exchange: string;
  venue?: string;
}

export interface MultiSelectListAccountsProps {
  items: Item[];
  selectedItems: Item[];
  setSelectedItems: (items: Item[]) => void;
  multiSelectDisabled?: boolean;
  // Opt-in — off by default so this generic, widely-reused component is
  // unaffected everywhere except where a caller explicitly wants it (the
  // Portfolio Performance "blur names for demo" toggle).
  isBlurred?: boolean;
}

export const MultiSelectListAccounts: React.FC<MultiSelectListAccountsProps> = ({
  items,
  selectedItems,
  setSelectedItems,
  multiSelectDisabled = false,
  isBlurred = false,
}) => {
  const handleCheckboxChange = (item: Item) => {
    const isChecked = selectedItems.some(
      (selectedItem) => selectedItem.name === item.name && selectedItem.exchange === item.exchange,
    );

    if (isChecked) {
      setSelectedItems(
        selectedItems.filter(
          (selectedItem) =>
            selectedItem.name !== item.name || selectedItem.exchange !== item.exchange,
        ),
      );
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const isChecked = (item: Item) =>
    selectedItems.some(
      (selectedItem) =>
        selectedItem.name === item.name &&
        selectedItem.exchange === item.exchange &&
        selectedItem.venue === item.venue,
    );

  return (
    <div className="multi-select-list-accounts">
      {items.map((item, index) => (
        <Tooltip
          key={`${item.name}-${index}`}
          title={!isBlurred && item.name.length >= 20 ? item.name : ''}
        >
          <label
            key={`${item.name}_${item.exchange}`}
            className={`checkbox-account-item ${multiSelectDisabled && 'checkbox-account-item-disabled'}`}
          >
            <Checkbox
              disabled={multiSelectDisabled}
              checked={isChecked(item)}
              onChange={() => handleCheckboxChange(item)}
            />
            <span
              style={
                isBlurred
                  ? { filter: 'blur(6px)', userSelect: 'none', transition: 'filter 150ms ease' }
                  : undefined
              }
            >
              {Utils.truncateLabel(item.name)}
            </span>
          </label>
        </Tooltip>
      ))}
    </div>
  );
};
